exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-card {\n  border: 1px solid #ccc;\n  margin: 20px 5px;\n  padding: 15px;\n  border-radius: 10px;\n  min-width: 300px;\n  max-width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n  .upload-card p {\n    margin-bottom: 0; }\n  @media screen and (max-width: 500px) {\n    .upload-card {\n      min-width: 100%; } }\n  .upload-card__title {\n    font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/client/invoices/invoice-small-card/invoice-small-card.component.scss
// module id = ../../../../../app/src/app/client/invoices/invoice-small-card/invoice-small-card.component.scss
// module chunks = invoices.module.0